export default __webpack_public_path__ + "static/CIC-5543e46611683ec7275356d775e9d90d.svg";